import * as AvatarPrimitive from "@radix-ui/react-avatar"
import * as React from "react"

import { LoadingSpinner } from "@shared/components/feedback/LoadingSpinner"
import { cn } from "@shared/lib/utils"

const Avatar = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      className
    )}
    {...props}
  />
))
Avatar.displayName = AvatarPrimitive.Root.displayName

interface AvatarLoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean
}

const AvatarLoading = React.forwardRef<
  HTMLDivElement,
  AvatarLoadingProps
>(({ className, isLoading = true, children, ...props }, ref) => {
  if (!isLoading) return null

  return (
    <div
      ref={ref}
      className={cn(
        "absolute inset-0 flex items-center justify-center rounded-full bg-black/30",
        className
      )}
      {...props}
    >
      {children ?? <LoadingSpinner size="md" />}
    </div>
  )
})
AvatarLoading.displayName = "AvatarLoading"

const AvatarImage = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn("aspect-square h-full w-full", className)}
    {...props}
  />
))
AvatarImage.displayName = AvatarPrimitive.Image.displayName

const AvatarFallback = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      className
    )}
    {...props}
  />
))
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName

export { Avatar, AvatarFallback, AvatarImage, AvatarLoading }

